import React, {Component} from 'react';
import {withRouter} from "../../hoc/withRouter";
import {Breadcrumb, Col, Row, Input, Button, Checkbox, Form, Divider, Modal, Radio, Upload, InputNumber, Space} from "antd";
import {UploadOutlined} from "@ant-design/icons";
import FooterSection from "../../component/pageSection/FooterSection";
import PageHeader from "../../component/header/PageHeader";
import {appDefaultArea} from "../../config/appDataConfig/appConfig";
import Cookies from "universal-cookie";
import {appName} from "../../config/appDataConfig/appConfig";
import {baseUrlCdnUpload} from "../../config/apiConfig/apiConfig";
import {bqBridgingService} from "../../services/BqBridging/BqBridgingService";
import "./formEvTaxi.css";

class FormDriverGSM extends Component<any, any> {
    private cookies = new Cookies();
    private readonly initState!: any;

    constructor(props: any) {
        super(props);

        if (!this.cookies.get('_amc-a')) {
            this.cookies.set('_amc-a', appDefaultArea);
        }

        this.initState = {
            isDesktop: false,
            areaCode: (this.cookies.get('_amc-a')) ? this.cookies.get('_amc-a') : appDefaultArea,
            
            // Form Fields
            sapId: "",
            nikKtp: "",
            namaSesuaiKtp: "",
            nomorWaAktif: "",
            
            // Upload URLs
            fotoKtpUrl: "",
            fotoKartuKeluargaUrl: "",
            fotoKtpPasanganUrl: "",
            
            // Upload states
            isUploadingKtp: false,
            isUploadingKK: false,
            isUploadingKtpPasangan: false,
            
            statusTempatTinggal: null,
            statusTempatTinggalOther: "",
            
            statusPernikahan: null,
            statusPernikahanOther: "",
            
            domisili: null,
            domisiliAlamat: "",
            
            // Aplikasi Driver
            appGreenSM: false,
            appGrab: false,
            appGojek: false,
            appIndrive: false,
            appMaxim: false,
            appLalaMove: false,
            appOther: false,
            appOtherText: "",
            
            statusKredit: null,
            dpReady: null,
            
            isSubmitting: false
        }
        this.state = {...this.initState}
    }

    handleResize = () => {
        if (window.innerWidth < 992) {
            this.setState({
                isDesktop: false,
            });
        } else {
            this.setState({
                isDesktop: true,
            });
        }
    }

    onAreaChange = async (data: any) => {
        this.cookies.set('_amc-a', data.city_group);
        await this.promisedSetState({
            areaCode: data.city_group,
        });
    }

    componentDidMount() {
        setTimeout(() => {
            window.scrollTo({top: 0, behavior: 'smooth'});
        }, 10);

        window.addEventListener("resize", this.handleResize.bind(this));
        this.handleResize();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize.bind(this));
    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    onFieldChange = (field: string, value: any) => {
        const currentState: any = {...this.state}
        
        switch (field) {
            case "sapId":
                value = value.replace(/[^0-9]/g, '');
                if (value.length > 10) {
                    value = value.substring(0, 10);
                }
                currentState.sapId = value;
                break;
            case "nikKtp":
                value = value.replace(/[^0-9]/g, '');
                if (value.length > 16) {
                    value = value.substring(0, 16);
                }
                currentState.nikKtp = value;
                break;
            case "namaSesuaiKtp":
                currentState.namaSesuaiKtp = value;
                break;
            case "nomorWaAktif":
                value = value.replace(/[^0-9]/g, '');
                if (value.length >= 2 && value.substring(0, 2) !== '08') {
                    value = value.substring(0, 1);
                }
                if (value.length > 13) {
                    value = value.substring(0, 13);
                }
                currentState.nomorWaAktif = value;
                break;
            case "statusTempatTinggal":
                currentState.statusTempatTinggal = value;
                if (value !== "Other") {
                    currentState.statusTempatTinggalOther = "";
                }
                break;
            case "statusTempatTinggalOther":
                currentState.statusTempatTinggalOther = value;
                break;
            case "statusPernikahan":
                currentState.statusPernikahan = value;
                if (value !== "Other") {
                    currentState.statusPernikahanOther = "";
                }
                break;
            case "statusPernikahanOther":
                currentState.statusPernikahanOther = value;
                break;
            case "domisili":
                currentState.domisili = value;
                if (value !== "Tidak Sesuai KTP") {
                    currentState.domisiliAlamat = "";
                }
                break;
            case "domisiliAlamat":
                currentState.domisiliAlamat = value;
                break;
            case "appOtherText":
                currentState.appOtherText = value;
                break;
            case "statusKredit":
                currentState.statusKredit = value;
                break;
            case "dpReady":
                currentState.dpReady = value;
                break;
        }

        this.setState({
            ...currentState,
        });
    }

    onCheckboxChange = (field: string, checked: boolean) => {
        this.setState({
            [field]: checked
        });
    }

    handleUploadKtp = (data: any) => {
        if (data?.file?.status === "done") {
            let newDocUrl;
            if (data?.file?.response?.data?.url_document) {
                newDocUrl = data?.file?.response?.data?.url_document;
            } else if (data?.file?.response?.data?.Location) {
                newDocUrl = data?.file?.response?.data?.Location;
            } else if (typeof data?.file?.response?.data === 'string') {
                newDocUrl = data?.file?.response?.data;
            }
            
            this.setState({
                fotoKtpUrl: newDocUrl || "",
                isUploadingKtp: false
            });
        }
        if (data?.file?.status === "uploading") {
            this.setState({ isUploadingKtp: true });
        }
        if (data?.file?.status === "removed") {
            this.setState({ fotoKtpUrl: "", isUploadingKtp: false });
        }
        if (data?.file?.status === "error") {
            Modal.error({
                title: 'Upload Gagal',
                content: 'Terjadi kesalahan saat mengupload Foto KTP.'
            });
            this.setState({ isUploadingKtp: false });
        }
    }

    handleUploadKK = (data: any) => {
        if (data?.file?.status === "done") {
            let newDocUrl;
            if (data?.file?.response?.data?.url_document) {
                newDocUrl = data?.file?.response?.data?.url_document;
            } else if (data?.file?.response?.data?.Location) {
                newDocUrl = data?.file?.response?.data?.Location;
            } else if (typeof data?.file?.response?.data === 'string') {
                newDocUrl = data?.file?.response?.data;
            }
            
            this.setState({
                fotoKartuKeluargaUrl: newDocUrl || "",
                isUploadingKK: false
            });
        }
        if (data?.file?.status === "uploading") {
            this.setState({ isUploadingKK: true });
        }
        if (data?.file?.status === "removed") {
            this.setState({ fotoKartuKeluargaUrl: "", isUploadingKK: false });
        }
        if (data?.file?.status === "error") {
            Modal.error({
                title: 'Upload Gagal',
                content: 'Terjadi kesalahan saat mengupload Foto Kartu Keluarga.'
            });
            this.setState({ isUploadingKK: false });
        }
    }

    handleUploadKtpPasangan = (data: any) => {
        if (data?.file?.status === "done") {
            let newDocUrl;
            if (data?.file?.response?.data?.url_document) {
                newDocUrl = data?.file?.response?.data?.url_document;
            } else if (data?.file?.response?.data?.Location) {
                newDocUrl = data?.file?.response?.data?.Location;
            } else if (typeof data?.file?.response?.data === 'string') {
                newDocUrl = data?.file?.response?.data;
            }
            
            this.setState({
                fotoKtpPasanganUrl: newDocUrl || "",
                isUploadingKtpPasangan: false
            });
        }
        if (data?.file?.status === "uploading") {
            this.setState({ isUploadingKtpPasangan: true });
        }
        if (data?.file?.status === "removed") {
            this.setState({ fotoKtpPasanganUrl: "", isUploadingKtpPasangan: false });
        }
        if (data?.file?.status === "error") {
            Modal.error({
                title: 'Upload Gagal',
                content: 'Terjadi kesalahan saat mengupload Foto KTP Pasangan.'
            });
            this.setState({ isUploadingKtpPasangan: false });
        }
    }

    validateForm = () => {
        let isValid = true;
        let errorMessage = "";

        if (!this.state.sapId || this.state.sapId.length !== 10) {
            isValid = false;
            errorMessage += "SAP ID (harus 10 digit), ";
        }
        if (!this.state.nikKtp || this.state.nikKtp.length !== 16) {
            isValid = false;
            errorMessage += "NIK KTP (harus 16 digit), ";
        }
        if (!this.state.namaSesuaiKtp) {
            isValid = false;
            errorMessage += "Nama Sesuai KTP, ";
        }
        if (!this.state.nomorWaAktif || this.state.nomorWaAktif.length < 10) {
            isValid = false;
            errorMessage += "Nomor WA Aktif (minimal 10 digit), ";
        }
        if (!this.state.fotoKtpUrl) {
            isValid = false;
            errorMessage += "Foto KTP, ";
        }
        if (!this.state.fotoKartuKeluargaUrl) {
            isValid = false;
            errorMessage += "Foto Kartu Keluarga, ";
        }
        if (!this.state.statusTempatTinggal) {
            isValid = false;
            errorMessage += "Status Tempat Tinggal, ";
        }
        if (this.state.statusTempatTinggal === "Other" && !this.state.statusTempatTinggalOther) {
            isValid = false;
            errorMessage += "Status Tempat Tinggal (Lainnya), ";
        }
        if (!this.state.statusPernikahan) {
            isValid = false;
            errorMessage += "Status Pernikahan, ";
        }
        if (this.state.statusPernikahan === "Other" && !this.state.statusPernikahanOther) {
            isValid = false;
            errorMessage += "Status Pernikahan (Lainnya), ";
        }
        if (this.state.statusPernikahan === "Menikah" && !this.state.fotoKtpPasanganUrl) {
            isValid = false;
            errorMessage += "Foto KTP Pasangan, ";
        }
        if (!this.state.domisili) {
            isValid = false;
            errorMessage += "Domisili, ";
        }
        if (this.state.domisili === "Tidak Sesuai KTP" && !this.state.domisiliAlamat) {
            isValid = false;
            errorMessage += "Alamat Domisili, ";
        }
        
        const anyApp = this.state.appGreenSM || this.state.appGrab || this.state.appGojek || 
            this.state.appIndrive || this.state.appMaxim || this.state.appLalaMove || this.state.appOther;
        if (!anyApp) {
            isValid = false;
            errorMessage += "Aplikasi Driver (pilih minimal satu), ";
        }
        if (this.state.appOther && !this.state.appOtherText) {
            isValid = false;
            errorMessage += "Aplikasi Driver (Lainnya), ";
        }
        if (!this.state.statusKredit) {
            isValid = false;
            errorMessage += "Status Kredit, ";
        }
        if (!this.state.dpReady || this.state.dpReady < 1) {
            isValid = false;
            errorMessage += "DP Ready, ";
        }

        return { isValid, errorMessage };
    }

    onSubmitForm = async () => {
        const { isValid, errorMessage } = this.validateForm();
        
        if (!isValid) {
            Modal.error({
                title: 'Proses Gagal',
                content: (<div>
                    Mohon Lengkapi data-data berikut: <br/><br/>
                    {errorMessage.split(",").map(function (itemError, i) {
                        return itemError.trim() ? <div key={i}>• {itemError.trim()}</div> : null;
                    })}
                </div>)
            });
            return;
        }

        // Collect driver apps - keep original values
        const driverApps = [];
        if (this.state.appGreenSM) driverApps.push("Green SM");
        if (this.state.appGrab) driverApps.push("Grab");
        if (this.state.appGojek) driverApps.push("Gojek");
        if (this.state.appIndrive) driverApps.push("Indrive");
        if (this.state.appMaxim) driverApps.push("Maxim");
        if (this.state.appLalaMove) driverApps.push("LalaMove");
        if (this.state.appOther) driverApps.push(this.state.appOtherText);

        // Determine residence status - keep original value
        const residenceStatus = this.state.statusTempatTinggal === "Other" 
            ? this.state.statusTempatTinggalOther 
            : this.state.statusTempatTinggal;

        // Determine marital status - keep original value
        const maritalStatus = this.state.statusPernikahan === "Other" 
            ? this.state.statusPernikahanOther 
            : this.state.statusPernikahan;

        // Determine domicile address
        const domicileAddress = this.state.domisili === "Tidak Sesuai KTP" 
            ? this.state.domisiliAlamat 
            : null;

        const formData: any = {
            personal_info: {
                sap_id: this.state.sapId,
                id_card_number: this.state.nikKtp,
                full_name: this.state.namaSesuaiKtp?.toUpperCase(),
                whatsapp_number: this.state.nomorWaAktif
            },
            documents: {
                id_card_photo_url: this.state.fotoKtpUrl,
                family_card_photo_url: this.state.fotoKartuKeluargaUrl,
                spouse_id_card_photo_url: this.state.fotoKtpPasanganUrl || null
            },
            status: {
                residence_status: residenceStatus,
                marital_status: maritalStatus,
                domicile_status: this.state.domisili,
                domicile_address: domicileAddress
            },
            driver_info: {
                registered_apps: driverApps
            },
            financial_info: {
                credit_history: this.state.statusKredit,
                down_payment_ready: this.state.dpReady
            },
            submitted_at: new Date().toISOString()
        };

        // Console log seluruh data
        console.log("=== DRIVER GSM OWNERSHIP PROGRAM FORM DATA ===");
        console.log(JSON.stringify(formData, null, 2));
        console.log("===============================================");

        // Set loading state
        this.setState({ isSubmitting: true });

        try {
            // Kirim data ke BqBridging menggunakan storeDataGsmDriver
            await bqBridgingService.storeDataGsmDriver(formData);
            
            // Reset form ke state awal
            this.setState({
                ...this.initState,
                areaCode: this.state.areaCode,
                isDesktop: this.state.isDesktop
            });

            // Tampilkan modal sukses
            Modal.success({
                title: 'Terima Kasih',
                content: (
                    <div>
                        <p>Data Anda telah berhasil disimpan.</p>
                        <p>Tim kami akan segera menghubungi Anda.</p>
                    </div>
                ),
                okText: 'Tutup',
                onOk: () => {
                    window.scrollTo({top: 0, behavior: 'smooth'});
                }
            });

        } catch (error: any) {
            Modal.error({
                title: 'Gagal Menyimpan Data',
                content: error.message || 'Terjadi kesalahan saat menyimpan data. Silakan coba lagi.'
            });
            console.error('Error submitting form:', error);
        } finally {
            this.setState({ isSubmitting: false });
        }
    }

    render() {
        const formItemStyle = {
            marginBottom: '15px'
        };

        const sectionTitleStyle = {
            fontSize: '16px', 
            color: '#384967', 
            fontWeight: 500
        };

        return (
            <>
                <PageHeader black={true} onAreaChangeProps={this.onAreaChange} areaCode={this.state.areaCode} isDesktop={this.state.isDesktop}/>

                <Row className={`pt-100`}>
                    <Col xxl={{span: 16, offset: 4}} xl={{span: 16, offset: 4}} lg={{span: 20, offset: 2}} md={{span: 20, offset: 2}} sm={{span: 24}} xs={{span: 24}}>
                        <Breadcrumb className={`pl-20`}>
                            <Breadcrumb.Item>Amarta {appName}</Breadcrumb.Item>
                            <Breadcrumb.Item>FORM AJU KREDIT DRIVER GSM</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                </Row>

                <Row className={`p-20 mt-20`} style={{backgroundColor: "#fff"}}>
                    <Col xxl={{span: 16, offset: 4}} xl={{span: 16, offset: 4}} lg={{span: 20, offset: 2}} md={{span: 20, offset: 2}} sm={{span: 24}} xs={{span: 24}}>
                        <div>
                            <div style={{textAlign: "center", fontSize: "170%", marginBottom: 7}}>FORM AJU KREDIT DRIVER GSM</div>
                            <div style={{textAlign: "center", fontSize: "100%", marginBottom: 20, color: "gray"}}>Silakan isi data Anda pada form di bawah ini</div>
                        </div>

                        <Form layout="vertical" className="ev-taxi-form">
                            
                            {/* A. Data Identitas */}
                            <Divider orientation="left" plain>
                                <span style={sectionTitleStyle}>A. Data Identitas</span>
                            </Divider>
                            <Row>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>SAP ID *</i>
                                        <Input 
                                            value={this.state.sapId} 
                                            onChange={event => this.onFieldChange("sapId", event.target.value)} 
                                            placeholder="Masukan SAP ID (10 digit)"
                                            maxLength={10}
                                            style={{width: '100%'}}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>NIK KTP *</i>
                                        <Input 
                                            value={this.state.nikKtp} 
                                            onChange={event => this.onFieldChange("nikKtp", event.target.value)} 
                                            placeholder="Masukan NIK KTP (16 digit)"
                                            maxLength={16}
                                            style={{width: '100%'}}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>Nama Sesuai KTP *</i>
                                        <Input 
                                            value={this.state.namaSesuaiKtp} 
                                            onChange={event => this.onFieldChange("namaSesuaiKtp", event.target.value)} 
                                            placeholder="Masukan Nama Sesuai KTP"
                                            style={{width: '100%'}}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>Nomor WA Aktif (untuk survey leasing) *</i>
                                        <Input
                                            value={this.state.nomorWaAktif}
                                            maxLength={13}
                                            placeholder="Format: 08xxxxxxxx"
                                            onChange={event => this.onFieldChange("nomorWaAktif", event.target.value)}
                                            style={{width: '100%'}}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>

                            {/* B. Upload Dokumen */}
                            <Divider orientation="left" plain>
                                <span style={sectionTitleStyle}>B. Upload Dokumen</span>
                            </Divider>
                            <Row>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>Foto KTP *</i>
                                        <br/>
                                        <Upload
                                            method="POST"
                                            action={baseUrlCdnUpload + "/upload-document/document-data"}
                                            maxCount={1}
                                            data={{
                                                document_name: (Math.random() + 1).toString(36).substring(7),
                                                company: "amarta",
                                                document_type: "driver_gsm_ktp",
                                            }}
                                            name="image"
                                            onChange={this.handleUploadKtp}
                                            listType="picture"
                                            accept="image/*,.pdf"
                                        >
                                            <Button icon={<UploadOutlined />} loading={this.state.isUploadingKtp}>
                                                Upload Foto KTP
                                            </Button>
                                        </Upload>
                                        {this.state.fotoKtpUrl && (
                                            <div style={{marginTop: 10}}>
                                                <div style={{color: 'green', marginBottom: 5}}>✓ Foto KTP berhasil diunggah</div>
                                                <img src={this.state.fotoKtpUrl} alt="Foto KTP" style={{maxWidth: '100%', maxHeight: '150px'}} />
                                            </div>
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>Foto Kartu Keluarga *</i>
                                        <br/>
                                        <Upload
                                            method="POST"
                                            action={baseUrlCdnUpload + "/upload-document/document-data"}
                                            maxCount={1}
                                            data={{
                                                document_name: (Math.random() + 1).toString(36).substring(7),
                                                company: "amarta",
                                                document_type: "driver_gsm_kk",
                                            }}
                                            name="image"
                                            onChange={this.handleUploadKK}
                                            listType="picture"
                                            accept="image/*,.pdf"
                                        >
                                            <Button icon={<UploadOutlined />} loading={this.state.isUploadingKK}>
                                                Upload Foto KK
                                            </Button>
                                        </Upload>
                                        {this.state.fotoKartuKeluargaUrl && (
                                            <div style={{marginTop: 10}}>
                                                <div style={{color: 'green', marginBottom: 5}}>✓ Foto KK berhasil diunggah</div>
                                                <img src={this.state.fotoKartuKeluargaUrl} alt="Foto KK" style={{maxWidth: '100%', maxHeight: '150px'}} />
                                            </div>
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>Foto KTP Pasangan (Bila sudah menikah)</i>
                                        <br/>
                                        <Upload
                                            method="POST"
                                            action={baseUrlCdnUpload + "/upload-document/document-data"}
                                            maxCount={1}
                                            data={{
                                                document_name: (Math.random() + 1).toString(36).substring(7),
                                                company: "amarta",
                                                document_type: "driver_gsm_ktp_pasangan",
                                            }}
                                            name="image"
                                            onChange={this.handleUploadKtpPasangan}
                                            listType="picture"
                                            accept="image/*,.pdf"
                                        >
                                            <Button icon={<UploadOutlined />} loading={this.state.isUploadingKtpPasangan}>
                                                Upload Foto KTP Pasangan
                                            </Button>
                                        </Upload>
                                        {this.state.fotoKtpPasanganUrl && (
                                            <div style={{marginTop: 10}}>
                                                <div style={{color: 'green', marginBottom: 5}}>✓ Foto KTP Pasangan berhasil diunggah</div>
                                                <img src={this.state.fotoKtpPasanganUrl} alt="Foto KTP Pasangan" style={{maxWidth: '100%', maxHeight: '150px'}} />
                                            </div>
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>

                            {/* C. Status & Domisili */}
                            <Divider orientation="left" plain>
                                <span style={sectionTitleStyle}>C. Status & Domisili</span>
                            </Divider>
                            
                            <Row style={{marginBottom: '20px'}}>
                                <Col span={24} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <i className={`text-small-grey-nopadding`}>Status Tempat Tinggal *</i>
                                    <div style={{marginTop: 10}}>
                                        <Radio.Group 
                                            onChange={(e) => this.onFieldChange("statusTempatTinggal", e.target.value)} 
                                            value={this.state.statusTempatTinggal}
                                        >
                                            <Space direction="vertical">
                                                <Radio value="Milik Sendiri">Milik Sendiri</Radio>
                                                <Radio value="Milik Orang Tua">Milik Orang Tua</Radio>
                                                <Radio value="Kontrak / Sewa">Kontrak / Sewa</Radio>
                                                <Radio value="Other">Other</Radio>
                                            </Space>
                                        </Radio.Group>
                                    </div>
                                </Col>
                                {this.state.statusTempatTinggal === "Other" && (
                                    <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                        <Input 
                                            value={this.state.statusTempatTinggalOther} 
                                            onChange={event => this.onFieldChange("statusTempatTinggalOther", event.target.value)} 
                                            placeholder="Sebutkan status tempat tinggal"
                                            style={{width: '100%'}}
                                        />
                                    </Col>
                                )}
                            </Row>

                            <Row style={{marginBottom: '20px'}}>
                                <Col span={24} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <i className={`text-small-grey-nopadding`}>Status Pernikahan *</i>
                                    <div style={{marginTop: 10}}>
                                        <Radio.Group 
                                            onChange={(e) => this.onFieldChange("statusPernikahan", e.target.value)} 
                                            value={this.state.statusPernikahan}
                                        >
                                            <Space direction="vertical">
                                                <Radio value="Belum Menikah">Belum Menikah</Radio>
                                                <Radio value="Menikah">Menikah</Radio>
                                                <Radio value="Cerai">Cerai</Radio>
                                                <Radio value="Other">Other</Radio>
                                            </Space>
                                        </Radio.Group>
                                    </div>
                                </Col>
                                {this.state.statusPernikahan === "Other" && (
                                    <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                        <Input 
                                            value={this.state.statusPernikahanOther} 
                                            onChange={event => this.onFieldChange("statusPernikahanOther", event.target.value)} 
                                            placeholder="Sebutkan status pernikahan"
                                            style={{width: '100%'}}
                                        />
                                    </Col>
                                )}
                            </Row>

                            <Row style={{marginBottom: '20px'}}>
                                <Col span={24} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <i className={`text-small-grey-nopadding`}>Domisili *</i>
                                    <div style={{marginTop: 10}}>
                                        <Radio.Group 
                                            onChange={(e) => this.onFieldChange("domisili", e.target.value)} 
                                            value={this.state.domisili}
                                        >
                                            <Space direction="vertical">
                                                <Radio value="Sesuai KTP">Sesuai KTP</Radio>
                                                <Radio value="Tidak Sesuai KTP">Tidak Sesuai KTP</Radio>
                                            </Space>
                                        </Radio.Group>
                                    </div>
                                </Col>
                                {this.state.domisili === "Tidak Sesuai KTP" && (
                                    <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                        <Input 
                                            value={this.state.domisiliAlamat} 
                                            onChange={event => this.onFieldChange("domisiliAlamat", event.target.value)} 
                                            placeholder="Masukan alamat domisili saat ini"
                                            style={{width: '100%'}}
                                        />
                                    </Col>
                                )}
                            </Row>

                            {/* D. Aplikasi Driver */}
                            <Divider orientation="left" plain>
                                <span style={sectionTitleStyle}>D. Aplikasi Driver</span>
                            </Divider>
                            
                            <Row style={{marginBottom: '15px'}}>
                                <Col span={24} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <i className={`text-small-grey-nopadding`}>Aplikasi Driver yang dimiliki (pilih yang sesuai) *</i>
                                </Col>
                                <Col xl={{span: 8}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                    <Checkbox 
                                        onChange={e => this.onCheckboxChange('appGreenSM', e.target.checked)} 
                                        checked={this.state.appGreenSM}
                                    >
                                        Green SM
                                    </Checkbox>
                                </Col>
                                <Col xl={{span: 8}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                    <Checkbox 
                                        onChange={e => this.onCheckboxChange('appGrab', e.target.checked)} 
                                        checked={this.state.appGrab}
                                    >
                                        Grab
                                    </Checkbox>
                                </Col>
                                <Col xl={{span: 8}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                    <Checkbox 
                                        onChange={e => this.onCheckboxChange('appGojek', e.target.checked)} 
                                        checked={this.state.appGojek}
                                    >
                                        Gojek
                                    </Checkbox>
                                </Col>
                                <Col xl={{span: 8}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                    <Checkbox 
                                        onChange={e => this.onCheckboxChange('appIndrive', e.target.checked)} 
                                        checked={this.state.appIndrive}
                                    >
                                        Indrive
                                    </Checkbox>
                                </Col>
                                <Col xl={{span: 8}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                    <Checkbox 
                                        onChange={e => this.onCheckboxChange('appMaxim', e.target.checked)} 
                                        checked={this.state.appMaxim}
                                    >
                                        Maxim
                                    </Checkbox>
                                </Col>
                                <Col xl={{span: 8}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                    <Checkbox 
                                        onChange={e => this.onCheckboxChange('appLalaMove', e.target.checked)} 
                                        checked={this.state.appLalaMove}
                                    >
                                        LalaMove
                                    </Checkbox>
                                </Col>
                                <Col xl={{span: 8}} xs={{span: 12}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                    <Checkbox 
                                        onChange={e => this.onCheckboxChange('appOther', e.target.checked)} 
                                        checked={this.state.appOther}
                                    >
                                        Other
                                    </Checkbox>
                                </Col>
                                {this.state.appOther && (
                                    <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5, marginTop: 10}}>
                                        <Input 
                                            value={this.state.appOtherText} 
                                            onChange={event => this.onFieldChange("appOtherText", event.target.value)} 
                                            placeholder="Sebutkan aplikasi lainnya"
                                            style={{width: '100%'}}
                                        />
                                    </Col>
                                )}
                            </Row>

                            {/* E. Status Kredit & DP */}
                            <Divider orientation="left" plain>
                                <span style={sectionTitleStyle}>E. Status Kredit & DP</span>
                            </Divider>
                            
                            <Row style={{marginBottom: '20px'}}>
                                <Col span={24} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <i className={`text-small-grey-nopadding`}>Status Kredit *</i>
                                    <div style={{marginTop: 10}}>
                                        <Radio.Group 
                                            onChange={(e) => this.onFieldChange("statusKredit", e.target.value)} 
                                            value={this.state.statusKredit}
                                        >
                                            <Space direction="vertical">
                                                <Radio value="Sudah Pernah Kredit dan Sudah Selesai">Sudah Pernah Kredit dan Sudah Selesai</Radio>
                                                <Radio value="Sudah Pernah Kredit dan Masih Berjalan">Sudah Pernah Kredit dan Masih Berjalan</Radio>
                                                <Radio value="Sudah Pernah Kredit dan Tidak Selesai (Collect)">Sudah Pernah Kredit dan Tidak Selesai (Collect)</Radio>
                                                <Radio value="Belum Pernah Kredit">Belum Pernah Kredit</Radio>
                                            </Space>
                                        </Radio.Group>
                                    </div>
                                </Col>
                            </Row>

                            <Row>
                                <Col xl={{span: 12}} xs={{span: 24}} style={{paddingLeft: 5, paddingRight: 5}}>
                                    <Form.Item style={formItemStyle}>
                                        <i className={`text-small-grey-nopadding`}>DP Ready *</i>
                                        <InputNumber 
                                            value={this.state.dpReady} 
                                            onChange={value => this.onFieldChange("dpReady", value)} 
                                            placeholder="Masukan besaran DP dalam Rupiah"
                                            min={0}
                                            formatter={value => `Rp ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value!.replace(/Rp\s?|(,*)/g, '')}
                                            style={{width: '100%'}}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Divider />
                            
                            <Button 
                                onClick={this.onSubmitForm} 
                                loading={this.state.isSubmitting} 
                                style={{backgroundColor: '#384967', width: "220px", borderColor: '#384967', color: '#fff', height: '45px', fontSize: '15px'}} 
                                danger
                            >
                                Kirim Data
                            </Button>
                        </Form>
                    </Col>
                </Row>

                <div style={{minHeight: 100}}/>
                <FooterSection/>
            </>
        );
    }
}
export default withRouter(FormDriverGSM);
